import {Component} from '@angular/core';
import {RouterLink} from "@angular/router";
import {NavigationComponent} from "../navigation/navigation.component";

@Component({
    selector: 'app-features',
    templateUrl: './features.component.html',
    styleUrl: './features.component.scss',
    imports: [
        RouterLink,
        NavigationComponent
    ]
})
export class FeaturesComponent {

}
